export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_33792.4f0c889a.jpg";